import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'

interface FolderHeaderProps {
  title?: string
  description?: string
  slug?: string
}

const FolderHeader = ({ title, description, slug }: FolderHeaderProps) => {
  if (!slug || !title || !description) {
    return null
  }

  return (
    <ResourceHeader
      title={title}
      description={description}
      avatar={{
        type: 'emoji',
        emoji: '📂',
      }}
    />
  )
}

export default FolderHeader
